import moment from 'moment';

export const DateTimeFormat = () => 'DD MMM YYYY hh:mm A';
export const DateFormat = () => 'DD MMM YYYY';
export const TimeFormat = () => 'hh:mm A';

const getFormattedDate = (date, formatPattern = 'DD MMM YYYY hh:mm A') => {
  if (!date) return null;
  return moment(date).format(formatPattern);
};

export default getFormattedDate;
